import axiosInstance from '../routes/axios-instance';
import handlerError from '../routes/error-handler';
import RoutesAPI from '../routes/api.routes';

export const CategoryModel = {
  id: 0,
  name: '',
  image: '',
};

export default {
  namespaced: true,
  state: {
    category: { ...CategoryModel },
    categories: [],
  },
  mutations: {
    add(state, element) {
      state.categories.push(element);
    },
    editOne(state, element) {
      state.category = element;
    },
    editAll(state, categories) {
      state.categories = categories;
    },
    update(state, element) {
      state.categories = state.categories.map(
        (value) => (element.id === value.id ? element : value),
      );
    },
    delete(state, id) {
      state.categories = state.categories.filter((element) => element.id !== id);
    },
  },
  actions: {
    async getCategory({ commit }, { appId, categoryId }) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.CATEGORIES_PATH}/${categoryId}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('editOne', response.data);
          }
        })
        .catch(handlerError);
    },
    async getCategories({ commit }, { appId }) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.CATEGORIES_PATH}`)
        .then((response) => {
          commit('editAll', response.data);
        })
        .catch(handlerError);
    },

    async create({ commit }, { appId, body }) {
      return axiosInstance.post(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.CATEGORIES_PATH}`, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('add', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async update({ commit }, { appId, categoryId, body }) {
      axiosInstance.put(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.CATEGORIES_PATH}/${categoryId}`, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('update', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, { appId, categoryId }) {
      axiosInstance.delete(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.CATEGORIES_PATH}/${categoryId}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('delete', categoryId);
          }
        })
        .catch(handlerError);
    },
  },
  getters: { },
};
